import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../services/axiosInstance";
import Loader from "../components/Loader";

export default function ForgotPassword() {

  const [email, setEmail] = useState("");
  const [loading,setLoading] = useState(false);
  const [error,setError] = useState("");

  const navigate = useNavigate();

  const sendOtp = async () => {

    if(!email){
      setError("Please enter your email");
      return;
    }
    try{
      setLoading(true);
      setError("");
      await axiosInstance.post("/password/forgotpassword", null,{
        params:{email}
      });
      navigate("/verify-otp",{state:{email}});
    }catch(err){
      alert("Email not found or failed to send OTP");
    }finally{
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
       {loading && <Loader />}
      <div className="bg-white shadow-xl rounded-2xl p-8 w-full max-w-md">

        <h2 className="text-2xl font-bold text-center text-gray-800 mb-4">
          Forgot Password
        </h2>

        <p className="text-gray-600 text-sm text-center mb-6">
          Enter your registered email address. We will send an OTP to reset your password.
        </p>

        {error && (
          <div className="bg-red-100 text-red-600 text-sm p-2 rounded mb-4">
            {error}
          </div>
        )}

        <input
          type="email"
          placeholder="Enter your email"
          className="w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <button
          onClick={sendOtp}
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 transition disabled:opacity-50"
        >
          {loading ? "Sending OTP..." : "Send OTP"}
        </button>

        <div className="text-center mt-6">
          <a
            href="/login"
            className="text-sm text-blue-600 hover:underline"
          > Back to Login
          </a>
        </div>

      </div>

    </div>
  );
}